﻿namespace eXpress.web.externaleditor {
	const orderService = new eXpress.services.OrderService(core.context);
	const getPrice = (pvc: string, quantity: number, variableAmount: number): JQueryPromise<core.IPriceDetails> => {
		return orderService.getPriceAsync(pvc, quantity, variableAmount, undefined, eXpress.utils.getCookie('promo'));
	};

	const getPvcByExternalCode = (externalCode: string) =>
		$.ajax({
			url: '/ajaxxhr/Editor/TastyPresentsEditorGetPvc',
			type: 'POST',
			global: false,
			contentType: 'application/json; charset=utf-8',
			data: '{ "externalCode": "' + externalCode + '" }',
			dataType: 'json'
		}).then(res => res as string);

	const addToBasket = (externalCode: string, text: string, amount: number, variableAmount: number) => {
		// Optionally, a definition was passed with the URL
		const def = utils.getParameter("def") || '';
		const cartId = utils.getParameter("cartId") || '';
		const theme = utils.getParameter("theme") || "";
		const crossSellFrom = utils.getParameter("crossSellFrom") || "";

		$.ajax({
			url: '/ajaxxhr/Editor/TastyPresentsEditorAddToBasket',
			type: 'POST',
			global: false,
			contentType: 'application/json; charset=utf-8',
			data: '{ "externalCode": "' + externalCode + '", "text": "' + text + '", "theme": "' + theme + '", "crossSellFrom": "' + crossSellFrom + '", "def": "' + def + '", "cartId": "' + cartId + '", "amount": "' + amount + '", "variableAmount": "' + variableAmount + '" }',
			dataType: 'json'
		}).then(res => {
			document.location.href = res;
		});
	};

	const editor = new components.content.createExternalEditor(html.querySelector(document, "chocotelegram-editor", true), html.querySelector(document, ".technical-amount", true), { getPrice, getPvcByExternalCode, addToBasket });
}
